import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { Branch, form_control } from "projects/sepidz-web-framework/src/lib/models";
import { Dictionary } from "projects/sepidz-web-framework/src/lib/models/dictionary";
import { RowState } from "projects/sepidz-web-framework/src/lib/models/enums";
import { takeUntil } from "rxjs/operators";
import { CheckBrachAccessModel } from "src/app/gnr/data-center-process/chek-branch-access.model";
import { CostGroup } from "../../model/CostGroup.model";
import { CostGroupBranch } from "../../model/costgroupbranch.model";
@Component({
  selector: "ngx-costgroup-form",
  templateUrl: "./costgroup-form.component.html",
  styleUrls: ["./costgroup-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CostGroupFormComponent extends BaseFormComponent<CostGroup> {
  deactivateSave: boolean = false;
  isAccessToAllBranches = true;
  Branch: form_control[];
  showBranch: boolean = false;
  DefaultValues: Dictionary = [];
  erroremessage: string;
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
    this.FillData();
  }
  async ngOnInit() {
    this.apiName = "CostGroup";
    this.label = this.translate("ClientApp.FrontOffice.Cost.Cost.CostGroup");
    super.ngOnInit();
    this.DefaultValues["CostGroupId"] = 0;
  }
  async FillData() {
    if (
      this.accountService.authService.currentInformation().BranchingLightEnabled ||
      this.accountService.authService.currentInformation().BranchingAdvancedEnabled
    ) {
      this.httpCommonService
        .getList("UserLocalSetting/GetValidationBranch" + "/CostGroup")
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((hbc: CheckBrachAccessModel) => {
          if (hbc.TransferKindCode != 3) {
            if ((hbc.TransferKindCode == 2 || hbc.TransferKindCode == 5) && hbc.HasCommunication == true && hbc.BranchCount == 1) {
              this.sts.showDialog(
                this.translate("ClientApp.FrontOffice.Cost.CostGroup.HasBranchCommunication"),
                this.translate("ClientApp.FrontOffice.Cost.CostGroup.Attention")
              );
              this.deactivateSave = true;
              return;
            } else {
              if ((hbc.TransferKindCode == 1 || hbc.TransferKindCode == 4) && hbc.BranchCount > 1) {
                this.sts.showDialog(
                  this.translate("ClientApp.FrontOffice.Cost.CostGroup.HasCallCenterCommunication"),
                  this.translate("ClientApp.FrontOffice.Cost.CostGroup.Attention")
                );
                this.deactivateSave = true;
                return;
              }
            }
          }
        });
      (error) => this.getFailedHelper(error);
    }

    if (!this.model.Branch) this.model.Branch = [];
    if (!this.accountService.authService.currentBranch) {
      setTimeout(() => this.populateBranch(), 300);
    } else {
      this.populateBranch();
    }
  }
  addControl() {
    this.cd.markForCheck();
  }
  setdefault(): void {
    if (!this.accountService.authService.currentBranch) {
      setTimeout(() => this.populateBranch(), 300);
    } else {
      this.populateBranch();
    }
  }
  populateBranch() {
    this.httpCommonService
      .getList("Branch")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(async (data: Branch[]) => {
        let BranchList: Branch[] = data;
        if (!this.model) this.model = <CostGroup>{};
        if (!this.model.Branch) this.model.Branch = [];
        BranchList?.forEach((br: Branch) => {
          const listBranch = this.model.Branch.find((x) => x.BranchId === br.Id);
          if (!listBranch) {
            let entity = <CostGroupBranch>{};
            entity.BranchId = br.Id;
            entity.BranchTitle = br.Title;
            entity.IsActive = true;
            entity.State = RowState.New;
            // اگر در مود ایجاد بودیم
            if (!this.model || !(this.model.Id > 0)) {
              entity.Selected = true;
            } else {
              entity.Selected = false;
            }

            this.model.Branch.push(entity);
            this.cd.markForCheck();
          }
        });

        this.showBranch = true;
      });
  }
  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.Branch = undefined;
  }
  beforupdate(): void {
    this.model.Branch = this.model.Branch.filter((x) => x.Selected);
    if (this.model.Branch && this.model.Branch.length <= 0) this.model.Branch = null;
  }
  isActveTab(): boolean {
    return true;
  }
  setMaxCode() {
    if (!this.currentrow?.Id) {
      this.httpCommonService
        .getMaxCode(this.apiName)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((data) => {
          if (!this.model) this.model = <CostGroup>{};
          if (data) {
            this.model["Code"] = data as number;
          }
          this.setFormGroup(this.model);
        });
    }
  }
  setColumnAttribute() {
    this.Branch = this.getDetailControlModels("Branch");
    this.orignalColumns.find((x) => x.name == "Code").isFloat = 1;
  }
  ngAfterViewInit(): void {
    this.FillData();
  }
}
